module.exports = __webpack_public_path__ + "static/media/Mobile_Wallet_graphic_2.b5fcd890.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileWalletsLanding/images/Mobile_Wallet_graphic_2.png
// module id = 1219
// module chunks = 0